// Copyright (c) StrangeBee 2024

import { QuerySelector } from 'thehive-sdk';

interface ComputeGetSelectorParams {
    alertId: string;
}

export const computeGetSelector = ({ alertId }: ComputeGetSelectorParams): QuerySelector => ({
    head: [{ name: 'getAlert', idOrName: alertId }],
    name: `get-alert-details-${alertId}`,
    extraData: ['caseNumber', 'importDate', 'status'],
});
